import CssType from "csstype";
import Cell from "../../../library/components/layout/Cell";
import Rows from "../../../library/components/layout/Rows";
import Columns from "../../../library/components/layout/Columns";
import appColors from "../../../app/appColors";


export default function CizelgeLegend(props: { miniWidth: number, miniHeight: number, textWidth: number, fontSize: CssType.Property.FontSize<string | number> | undefined, items: { text: string, color: string }[] }) {
    return <div style={{ display: "flex", alignSelf: "center", height: "100%", width: "100%", placeContent: "center" }}>
        <Rows style={{ alignSelf: "center", flexGrow: 0, borderColor: appColors.BLACK, borderStyle: "solid", borderWidth: 1 }}>
            {props.items.map(item =>
                <Columns key={item.text} height={props.miniHeight} hasVeryLightBottomBorder>
                    {!item.color ?
                        <Cell flex pt={3} style={{ fontWeight: "bold", fontSize: props.fontSize, textAlign: "center", background: appColors.GRAY_LIGHT4 }}>{item.text}</Cell>
                        :
                        <>
                            <Cell pr={3} pt={3} width={props.textWidth} style={{ fontSize: props.fontSize, textAlign: "right" }}>{item.text}</Cell>
                            <div style={{ width: props.miniWidth, height: props.miniHeight, backgroundColor: item.color }}>
                            </div>
                        </>
                    }

                </Columns>
            )}
        </Rows>
    </div>;
}